import React from 'react';
import { initialState, generalReducer } from './generalReducer';

const GeneralStateContext = React.createContext();
const GeneralDispatchContext = React.createContext();

const GeneralProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(generalReducer, initialState);

  return (
    <GeneralStateContext.Provider value={state}>
      <GeneralDispatchContext.Provider value={dispatch}>{children}</GeneralDispatchContext.Provider>
    </GeneralStateContext.Provider>
  );
};

const useGeneralState = () => {
  const context = React.useContext(GeneralStateContext);
  if (context === undefined) {
    throw new Error('useGeneralState must be under GeneralProvider!');
  }
  return context;
};

const useGeneralDispatch = () => {
  const context = React.useContext(GeneralDispatchContext);
  if (context === undefined) {
    throw new Error('useGeneralDispatch must be under GeneralProvider!');
  }
  return context;
};

export { GeneralProvider, useGeneralDispatch, useGeneralState };
